import React, { Component } from  'react';
import stringHash from 'string-hash';
import * as stringify from "json-stringify-pretty-compact";
import {
  Modal, Row, InputGroup, Form, Button, Card, Col
} from 'react-bootstrap'
import './css/RecomModal.css';
import { debounce } from 'vega';
import AnimContainer from './AnimContainer';


class RecomModal extends Component {
  constructor(props){
    super(props);

    this.debouncedUpdateDuration = debounce(700, this.updateRecomParam.bind(this));
    this.debouncedUpdateDataJoinKey = debounce(700, this.updateRecomParam.bind(this));
  }

  render() {
    return<Modal
    size="lg"
    show={this.props.modalShow}
    onHide={this.props.onHide}
    aria-labelledby="example-modal-sizes-title-lg"
    id="recom-modal"
    >
    <Modal.Header closeButton>
      <Modal.Title id="example-modal-sizes-title-lg">
        Recommendations
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="mb-3 d-inline-flex felx-row">


          <InputGroup size="sm" className="mr-2" style={{"maxWidth": 155}}>
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="stageNSelect">
                # of Stages
              </InputGroup.Text>
            </InputGroup.Prepend>

            <Form.Control
              as="select"
              value={this.props.recomParameters.stageN}
              id="stageNSelect"
              onChange={this.onChangeStageN.bind(this)}
              style={{"maxWidth": 55}}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </Form.Control>
          </InputGroup>


          <InputGroup size="sm" className="mr-2" style={{"maxWidth": 150}}>
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="duration">
                Duration
              </InputGroup.Text>
            </InputGroup.Prepend>

            <Form.Control
              id="duration"
              placeholder="Milliseconds"
              aria-label="duration"
              aria-describedby="duration"
              type="number"
              min={0}
              defaultValue={this.props.recomParameters.duration}
              onChange={this.onChangeDuration.bind(this)}
            ></Form.Control>
          </InputGroup>



          <InputGroup size="sm" className="mr-2">
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="dataJoinKey">
                Data Join By
              </InputGroup.Text>
            </InputGroup.Prepend>

            <Form.Control
              id="dataJoinKey"
              placeholder='e.g., "name; year"'
              aria-label="dataJoinKey"
              aria-describedby="dataJoinKey"
              type="text"
              defaultValue={this.props.recomParameters.dataJoinKey}
              onChange={this.onChangeDataJoinKey.bind(this)}
            ></Form.Control>
          </InputGroup>

          <InputGroup size="sm" className="mr-2" >
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="x-domain-dimension">
                X Domain Dimension
              </InputGroup.Text>
            </InputGroup.Prepend>

            <Form.Control
              as="select"
              value={this.props.recomParameters.xScaleDomainDimension || "default"}
              id="x-domain-dimension"
              onChange={this.onChangeXScaleDomainDimension.bind(this)}
              style={{"minWidth": 70}}
            >
              <option value="default">Default</option>
              <option value="diff">Change</option>
              <option value="same">UnChange</option>
            </Form.Control>
          </InputGroup>
{/*
          <InputGroup size="sm" className="mr-2">
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="x-domain-dimension">
                X Keeps Domain Dimension
              </InputGroup.Text>
            </InputGroup.Prepend>
            <div className="form-control" style={{"maxWidth": 35}}>
              <Form.Check
                id="x-domain-dimension"
                placeholder='e.g., "name; year"'
                aria-label="X-Axis Keeps Domain Dimension"
                aria-describedby="x-domain-dimension"
                type="checkbox"
                checked={this.props.recomParameters.xScaleDomainDimension === "same"}
                onChange={this.onChangeXScaleDomainDimension.bind(this)}
              ></Form.Check>
            </div>
          </InputGroup> */}

          <InputGroup size="sm" className="mr-2" >
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="y-domain-dimension">
                Y Domain Dimension
              </InputGroup.Text>
            </InputGroup.Prepend>

            <Form.Control
              as="select"
              value={this.props.recomParameters.yScaleDomainDimension || "default"}
              id="y-domain-dimension"
              onChange={this.onChangeYScaleDomainDimension.bind(this)}
              style={{"minWidth": 70}}
            >
              <option value="default">Default</option>
              <option value="diff">Change</option>
              <option value="same">UnChange</option>
            </Form.Control>
          </InputGroup>
          {/* <InputGroup size="sm" className="mr-2">
            <InputGroup.Prepend>
              <InputGroup.Text htmlFor="y-domain-dimension">
                Y Keeps Domain Dimension
              </InputGroup.Text>
            </InputGroup.Prepend>
            <div className="form-control" style={{"maxWidth": 35}}>
              <Form.Check
                id="y-domain-dimension"
                placeholder='e.g., "name; year"'
                aria-label="Y-Axis Keeps Domain Dimension"
                aria-describedby="y-domain-dimension"
                type="checkbox"
                onChange={this.onChangeYScaleDomainDimension.bind(this)}
                checked={this.props.recomParameters.yScaleDomainDimension === "same"}
              />
            </div>
          </InputGroup> */}

      </div>
      <Row id="recommendations">
        {
          this.props.recoms.length === 0
          ? <Col>
            There is no recommendation with the given parameters.
          </Col>
          : this.props.recoms.map((recom, i) => {
            return <Col md={4} key={`recom${i}Card-${stringHash(JSON.stringify(this.props.recomParameters))}`}>
              <Card>
                <Card.Body>
                  <AnimContainer
                    sSpec={this.props.sSpec}
                    eSpec={this.props.eSpec}
                    gemSpec={recom.spec}
                    showMetaInfo={true}
                    meta={{cost: recom.pseudoTimeline.eval.cost, stageN: recom.spec.timeline.concat.length}}
                    id={`recom${i}`}
                  />
                  <Button
                    variant="primary" size="sm"
                    onClick={this.getCustomizeBtnClickHandler(recom.spec)}
                  >
                    Customize
                  </Button>
                </Card.Body>
              </Card>
            </Col>

          })
        }
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" size="sm" onClick={this.props.onHide}>Close</Button>
    </Modal.Footer>
  </Modal>

  }
  componentDidUpdate() {
    let dataJoinInputElm = document.getElementById("dataJoinKey"),
      durationElm = document.getElementById("duration");

    if (dataJoinInputElm && dataJoinInputElm.value !== this.props.recomParameters.dataJoinKey) {
      dataJoinInputElm.value = this.props.recomParameters.dataJoinKey;
    }
    if (durationElm && (durationElm.value * 1.0) !== this.props.recomParameters.duration) {
      durationElm.value = this.props.recomParameters.duration;
    }
  }
  updateRecomParam(param) {
    this.props.updateRecomParameters(param)
  }

  onChangeStageN(event) {
    this.props.updateRecomParameters({stageN: event.target.value})
  }

  onChangeDuration(event) {
    let duration = event.target.value*1.0;
    this.debouncedUpdateDuration.bind(this)({duration: duration})
  }

  onChangeDataJoinKey(event) {
    let dataJoinKey = event.target.value;
    this.debouncedUpdateDataJoinKey.bind(this)({dataJoinKey: dataJoinKey})
  }

  onChangeXScaleDomainDimension(event) {
    this.props.updateRecomParameters({xScaleDomainDimension: event.target.value})
  }

  onChangeYScaleDomainDimension(event) {
    this.props.updateRecomParameters({yScaleDomainDimension: event.target.value})
  }
  getCustomizeBtnClickHandler(spec) {
    return (event) => {
      this.props.setValueOnEditor(stringify(spec, null, 2));
      this.props.onHide()
    }
  }

}

export default RecomModal;
